import dayjs from 'dayjs';

import type {ConferenceApiModel} from '../../../api/conference';
import type {CoreOrB2b} from '../../coreOrB2b/types';
import type {Nullable} from '../../utility-types';

import {allOf, not} from '../../conditionalUtils';
import {pickCoreOrB2b} from '../../coreOrB2b/pickCoreOrB2b';
import {datetimeObjToISOString} from '../../datetime';
import {isDefined} from '../../typecheck';
import {isConferenceEnded} from './isConferenceEnded';
import {isConferenceStarted} from './isConferenceStarted';

export const MINS_FOR_CONFERENCE_EXPIRATION: CoreOrB2b<number, number> = {
  b2b: 30,
  core: 15,
};

export const isConferenceExpired = (
  conference?: Nullable<ConferenceApiModel>,
) => {
  const EXPIRED_TIMEOUT: {
    unit: dayjs.ManipulateType;
    value: number;
  } = {
    unit: 'minute',
    value: pickCoreOrB2b(MINS_FOR_CONFERENCE_EXPIRATION)!,
  };

  if (isDefined(conference)) {
    const isExpiredByTimeout =
      dayjs() >
      dayjs(datetimeObjToISOString(conference.start_date)).add(
        EXPIRED_TIMEOUT.value,
        EXPIRED_TIMEOUT.unit,
      );

    return allOf([
      not(isConferenceStarted(conference)),
      not(isConferenceEnded(conference)),
      isExpiredByTimeout,
    ]);
  }

  return false;
};
